import { render, staticRenderFns } from "./fieldtype_bool.vue?vue&type=template&id=65169b88&scoped=true&"
import script from "./fieldtype_bool.vue?vue&type=script&lang=js&"
export * from "./fieldtype_bool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65169b88",
  null
  
)

export default component.exports